import vuestore from '@/store';
import { DomainStore } from './store/domains.store';
import { IstatStore } from './store/istat.store';

export function init() {
    //REGISTRAZIONE DELLO STORE
    vuestore.registerModule(DomainStore.PREFIX, DomainStore);
    vuestore.registerModule(IstatStore.PREFIX, IstatStore);
}